module.exports = __webpack_public_path__ + "img/about-basketball.caafc1aa.png";